import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { ExternalLink } from '../../components';
import isAllowedForumThreadUrl from '../../util/isAllowedForumThreadUrl';

import css from './OrderPanel.module.css';

/**
 * Full-width secondary-styled link to the XenForo thread for this listing.
 *
 * @param {object} props
 * @param {string} [props.xfThreadUrl]
 * @param {string} [props.className]
 * @param {boolean} [props.flush] - Skip wrapper side padding (product layout already gutters)
 * @param {boolean} [props.mobileOnly] - Visible below --viewportLarge (listing page main column)
 * @param {boolean} [props.desktopOnly] - Visible at --viewportLarge and up (order panel form)
 * @param {'belowMap'|'aboveSubmit'} [props.placement] - Layout-specific spacing
 */
const JoinDiscussionMaybe = props => {
  const { xfThreadUrl, className, flush, mobileOnly, desktopOnly, placement } = props;
  const url = xfThreadUrl != null ? String(xfThreadUrl).trim() : '';

  if (!url || !isAllowedForumThreadUrl(url)) {
    return null;
  }

  const placementClass =
    placement === 'belowMap'
      ? css.joinDiscussionBelowMap
      : placement === 'aboveSubmit'
      ? css.joinDiscussionAboveSubmit
      : null;

  return (
    <div
      className={classNames(
        css.joinDiscussionWrapper,
        flush && css.joinDiscussionFlush,
        placementClass,
        mobileOnly && css.joinDiscussionMobileOnly,
        desktopOnly && css.joinDiscussionDesktopOnly,
        className
      )}
    >
      <ExternalLink href={url} className={css.joinDiscussionButton}>
        <FormattedMessage id="ListingPage.joinDiscussion" />
      </ExternalLink>
    </div>
  );
};

export default JoinDiscussionMaybe;
